/* eslint-disable
    func-names,
    no-shadow,
    prefer-rest-params,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Collection of all bookkeepers
const deps = ['Person', 'Collection'];

const factory = function (Person, Collection) {
  let BookkeeperCollection;
  return (BookkeeperCollection = (function () {
    BookkeeperCollection = class BookkeeperCollection extends Collection {
      static initClass() {
        this.prototype.$id = 'bookkeeper';

        this.prototype.$resource = 'person';

        this.prototype.$type = Person;
      }

      $init() {
        super.$init(...arguments);

        if (this.$lastUpdated === 0) {
          return this.$fetch();
        }
      }

      $url() {
        return `${super.$url()}/bookkeeper/`;
      }
    };
    BookkeeperCollection.initClass();
    return BookkeeperCollection;
  })());
};

factory.$inject = deps;

module.exports = angular
  .module('bench.data.collection.bookkeeper', [
    require('data/model/person').name,
    require('data/util').name,
  ])
  .factory('BookkeeperCollection', factory);
